import AddIcon from "@mui/icons-material/Create"
import PdfIcon from "@mui/icons-material/PictureAsPdf"
import RecordTypeIcon from "@mui/icons-material/PostAdd"
import CsvIcon from "@mui/icons-material/TableView"
import { IntlShape } from "react-intl"

/**
 * Speed Dial Action types
 */
export type Action = {
  id: string
  icon: any
  name: string
}

const getExportActions = (intl: IntlShape) => {
  return [
    {
      id: "pdf",
      icon: <PdfIcon />,
      name: intl.formatMessage({
        id: "button.export.pdf",
      }),
    },
    {
      id: "excel",
      icon: <CsvIcon />,
      name: intl.formatMessage({
        id: "button.export.excel",
      }),
    },
  ]
}

export const getRecordListSpeedDialActions = (intl: IntlShape): Action[] => {
  return [
    {
      id: "record",
      icon: <AddIcon />,
      name: intl.formatMessage({
        id: "button.new.data",
      }),
    },
    {
      id: "recordType",
      icon: <RecordTypeIcon />,
      name: intl.formatMessage({
        id: "dialog.title.record.types",
      }),
    },
    ...getExportActions(intl),
  ]
}

export const getInvoiceListSpeedDialActions = (intl: IntlShape): Action[] => {
  return [
    {
      id: "invoice",
      icon: <AddIcon />,
      name: intl.formatMessage({
        id: "button.new.invoice",
      }),
    },
    ...getExportActions(intl),
  ]
}

export const getInventoryListSpeedDialActions = (intl: IntlShape): Action[] => {
  return [
    {
      id: "inventory",
      icon: <AddIcon />,
      name: intl.formatMessage({
        id: "button.new.inventory",
      }),
    },
    ...getExportActions(intl),
  ]
}

export const getBuyerListSpeedDialActions = (intl: IntlShape): Action[] => {
  return [
    {
      id: "buyer",
      icon: <AddIcon />,
      name: intl.formatMessage({
        id: "button.new.buyer",
      }),
    },
    ...getExportActions(intl),
  ]
}
